import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';

@Component({
  selector: 'app-loginwith-otp',
  templateUrl: './loginwith-otp.component.html',
  styleUrls: ['./loginwith-otp.component.scss'],
})
export class LoginwithOTPComponent implements OnInit {

  userEmailOrPhone: string = '';
  otpSent: boolean = false;
  otpModalOpen: boolean = false;

  otpDigits: string[] = ['', '', '', '', '', ''];
  otpLength: number = 4; // change to 6 if needed

  resendCountdown: number = 30;
  timer: any;

  constructor(private http: HttpService, private config: Config) {}

  ngOnInit() {}

  // ----------------- OTP Modal Control -----------------
  openOtpModal() {
    this.otpModalOpen = true;
  }

  closeOtpModal() {
    this.otpModalOpen = false;
    this.reset();
  }

  // ----------------- Step 1: Send OTP -----------------
  sendOtp() {
    if (!this.userEmailOrPhone) return;

    const payload = { email: this.userEmailOrPhone };
    console.log('Sending OTP to:', this.userEmailOrPhone);

    this.http.callPostServiceForLogin(this.config.sendOtp, payload).subscribe({
      next: (data: any) => {
        console.log('OTP sent:', data);
        this.otpSent = true;
        this.startTimer();
      },
      error: (err) => {
        console.error('Error sending OTP:', err);
      }
    });
  }

  // ----------------- Step 2: Verify OTP -----------------
  verifyOtp() {
    const otp = this.otpDigits.join('');
    if (otp.length < this.otpLength) {
      alert('Please enter complete OTP');
      return;
    }

    const payload = { email: this.userEmailOrPhone, otp };
    this.http.callPostService('/api/auth/verify-otp', payload).subscribe({
      next: (res) => {
        console.log('OTP verified:', res);
        alert('Login successful!');
        this.closeOtpModal();
      },
      error: (err) => {
        console.error('OTP verification failed:', err);
      },
    });
  }

  // ----------------- Timer & Resend -----------------
  startTimer() {
    this.resendCountdown = 30;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown === 0) clearInterval(this.timer);
    }, 1000);
  }

  resendOtp() {
    this.sendOtp();
  }

  // ----------------- Input Navigation -----------------
  moveNext(event: any, index: number) {
    const input = event.target;
    if (input.value && index < this.otpLength - 1) {
      input.nextElementSibling?.focus();
    }
  }

  // ----------------- Reset -----------------
  reset() {
    this.otpSent = false;
    this.userEmailOrPhone = '';
    this.otpDigits = ['', '', '', '', '', ''];
    clearInterval(this.timer);
  }
}
